var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("header", { attrs: { id: "header", "data-html2canvas-ignore": true } }, [
      _c("h1", [
        _c(
          "div",
          { staticClass: "group-image-logo" },
          [
            _c("img", {
              staticClass: "crepologo",
              attrs: { src: _vm.crepologo, alt: _vm.$t("default_title") },
              on: { click: _vm.goToHome },
            }),
            _vm._v(" "),
            _c("HeaderBrandTagline"),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "subnavi" },
        [
          _vm.$route.name !== "Plug" && _vm.authUser && _vm.authUser.id
            ? [
                _vm.authUser
                  ? [
                      _c("li", [
                        _c(
                          "div",
                          { staticClass: "btn-group-plan" },
                          [
                            _vm.authUser.plan &&
                            (_vm.authUser.plan.plan_type === _vm.planFree ||
                              _vm.authUser.plan.plan_type === _vm.planTrial)
                              ? [
                                  _c("div", { staticClass: "plan-wrapper" }, [
                                    _c(
                                      "div",
                                      [
                                        _vm.hasSubscribedPlan(_vm.authUser)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center",
                                              },
                                              [
                                                _c("span", {
                                                  class: [
                                                    _vm.isPlanExpired
                                                      ? "icon-ai-valuation"
                                                      : "icon-ai-valuation-red",
                                                  ],
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.authUser.plan[
                                                        `name${
                                                          _vm.getCurrentLanguage !=
                                                          "ja"
                                                            ? `_${_vm.getCurrentLanguage}`
                                                            : ""
                                                        }`
                                                      ]
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasSubscribedPlanGenerate(
                                          _vm.authUser
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center",
                                              },
                                              [
                                                _c("span", {
                                                  class: [
                                                    _vm.isUserPlanGenerate
                                                      ? "icon-plan-generate-red"
                                                      : "icon-plan-generate",
                                                  ],
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.authUser
                                                        .plan_generate[
                                                        `name${
                                                          _vm.getCurrentLanguage !=
                                                          "ja"
                                                            ? `_${_vm.getCurrentLanguage}`
                                                            : ""
                                                        }`
                                                      ]
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.authUser.plan.plan_type ===
                                        _vm.planFree
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn-choose-plan",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.changePlan()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("special_plan")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.shouldShowChangeToUnlimitedPlan()
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn-choose-plan",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changePlan()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getGenerateTrialPlanChangeButtonLabel()
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm.authUser.plan.plan_type ===
                                            _vm.planTrial
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn-choose-plan",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goToUpdateInfoUserTrial()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "change_to_special_plan_from_trial"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]
                              : [
                                  _c("span", { staticClass: "plan-name" }, [
                                    _vm._v(_vm._s(_vm.$t("current_plan"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "plan-wrapper" }, [
                                    _c("div", [
                                      _vm.hasSubscribedPlan(_vm.authUser)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center",
                                            },
                                            [
                                              _c("span", {
                                                class: [
                                                  _vm.isPlanExpired
                                                    ? "icon-ai-valuation"
                                                    : "icon-ai-valuation-red",
                                                ],
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.authUser.plan[
                                                      `name${
                                                        _vm.getCurrentLanguage !=
                                                        "ja"
                                                          ? `_${_vm.getCurrentLanguage}`
                                                          : ""
                                                      }`
                                                    ]
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasSubscribedPlanGenerate(
                                        _vm.authUser
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center",
                                            },
                                            [
                                              _c("span", {
                                                class: [
                                                  _vm.isUserPlanGenerate
                                                    ? "icon-plan-generate-red"
                                                    : "icon-plan-generate",
                                                ],
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.authUser.plan_generate[
                                                      `name${
                                                        _vm.getCurrentLanguage !=
                                                        "ja"
                                                          ? `_${_vm.getCurrentLanguage}`
                                                          : ""
                                                      }`
                                                    ]
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _vm.isAdmin && _vm.authUser.setting_plan
                                      ? _c("i", {
                                          staticClass:
                                            "fa far fa-edit icon-change-plan",
                                          on: { click: _vm.goToPlanRenew },
                                        })
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _vm.shouldShowChangeToUnlimitedPlan()
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn-choose-plan",
                                          on: {
                                            click: function ($event) {
                                              return _vm.changePlan()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getGenerateTrialPlanChangeButtonLabel()
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showMaxImage
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("limit", {
                                              max_images: _vm.maxImagesOfUser,
                                            })
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                          ],
                          2
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isSuperAdmin
                  ? [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: _vm.isAdmin ? "MypageIndex" : "Users",
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("my_page")))]
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("li", [
                  _c("a", { on: { click: _vm.logout } }, [
                    _c("i", { staticClass: "fa fa-sign-out pr5" }),
                    _vm._v(_vm._s(_vm.$t("logout"))),
                  ]),
                ]),
              ]
            : [
                _c("li", [
                  _c("a", { on: { click: _vm.logout } }, [
                    _c("i", { staticClass: "ti-lock pr5" }),
                    _vm._v(_vm._s(_vm.$t("click_here_for_member"))),
                  ]),
                ]),
              ],
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "body-inner" },
      [_c("router-view", { key: _vm.$route.fullPath })],
      1
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "footer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }